
// region JS Imports

// region External Modules
import $ from "jquery"

import * as Routes from "plugins/js-routes"
// endregion External Modules

// Private Modules
import Goals from "app/tracking/goals/track"
import DataRetriever from "app/data_retriever"
import YahooGemini_Conversions from "app/tracking/yahoo_gemini/conversions"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface InputSelector {
  scope?:  string | JQuery
  btn?:    string
}
const DEFAULT_SELECTOR = {
  scope:  ".cell-serviced-apartment-contact-request-box",
  btn:    ".cell-serviced-apartment-contact-request-box__contact-phone--btn",
}

const init = (selector?: InputSelector) => {
  const sele = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = $(sele.scope)
  const $btns = $scope.find(sele.btn)

  $btns.on("click", (e) => {
    const $button = $(e.currentTarget)

    const listing_id = $button.data("listing-id")
    const tracking_distinct_id = DataRetriever.get("tracking-distinct-id")

    Goals.ListingContactSuccessByPhone.track(
      Goals.ListingContactSuccessByPhone.PropertyTypeLabels.SERVICED_APARTMENT,
    )
    YahooGemini_Conversions.SendPhoneEnquiry.track()

    q_ajax_3({
      url:      Routes.api_web_app_listing_tracking_events_with_type_contact_by_phone_success_index_path(),
      method:   "POST",
      dataType: "json",
      data:     {
        listing_id:           listing_id,
        tracking_distinct_id: tracking_distinct_id,
      },
    })
    .done()
  })
}

export default {init}
